module.exports = __webpack_public_path__ + "static/Digistore24-b98717a29ef0688a1a73d63e3f13e679.svg";